const {
  GET_SERVICE_RECORDS_SUCCESS,
  GET_SERVICE_RECORDS_FAIL,
  ADD_SERVICE_RECORD_SUCCESS,
  ADD_SERVICE_RECORD_FAIL,
  DELETE_SERVICE_RECORD_SUCCESS,
  DELETE_SERVICE_RECORD_FAIL,
  UPDATE_SERVICE_RECORD_SUCCESS,
  UPDATE_SERVICE_RECORD_FAIL,
  SERVICE_RECORDS_BY_ID_SUCCESS,
  SERVICE_RECORDS_BY_ID_FAIL,
  SERVICE_RECORD_ADD_FILE_SUCCESS,
  SERVICE_RECORD_ADD_FILE_FAIL,
  SERVICE_RECORD_DELETE_FILE_SUCCESS,
  SERVICE_RECORD_DELETE_FILE_FAIL,
  GET_SERVICE_RECORD_LOGS_SUCCESS,
  GET_SERVICE_RECORD_LOGS_FAIL,
} = require("./actionType");

const INIT_STATE = {
  list: [],
  error: [],
  res: [],
  delRes: [],
  details: [],
  logs: [],
};

const ServiceRecord = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SERVICE_RECORD_DELETE_FILE_SUCCESS:
      return {
        ...state,
        delRes: action.payload,
      };
    case SERVICE_RECORD_DELETE_FILE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_SERVICE_RECORD_LOGS_SUCCESS:
      return {
        ...state,
        logs: action.payload,
      };
    case GET_SERVICE_RECORD_LOGS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SERVICE_RECORD_ADD_FILE_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case SERVICE_RECORD_ADD_FILE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SERVICE_RECORDS_BY_ID_SUCCESS:
      return {
        ...state,
        details: action.payload,
      };
    case SERVICE_RECORDS_BY_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_SERVICE_RECORD_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case UPDATE_SERVICE_RECORD_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_SERVICE_RECORD_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case ADD_SERVICE_RECORD_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_SERVICE_RECORD_SUCCESS:
      return {
        ...state,
        delRes: action.payload,
      };
    case DELETE_SERVICE_RECORD_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_SERVICE_RECORDS_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };
    case GET_SERVICE_RECORDS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default ServiceRecord;
